import { twMerge } from "tailwind-merge";

import Image from "@/assets/images/bottom.svg";

export type CTAProps = {
    className?: string
    children: React.ReactNode
    leading?: React.ReactNode
    trailing?: React.ReactNode
}

const CTA = (props: CTAProps) => {

    return (
        <div 
            className={twMerge(
                "bg-gradient-to-b from-[#FFEFE0] via-transparent to-white border border-secondary-100 rounded-lg px-4 pb-4 max-w-sm", 
                props.className
            )}
        >
            <div className="flex flex-col justify-between gap-4">
                <div>
                    <div className="flex">
                        <img
                            src={Image}
                            alt="illustration"
                            className="w-auto h-32"
                        />
                    </div>
                    {props.children}
                </div>
                {props.trailing}
            </div>
        </div>
    )
}

export default CTA